{
  "overview.greeting_morning": "Good morning, {name}",
  "overview.greeting_afternoon": "Good afternoon, {name}",
  "overview.greeting_evening": "Good evening, {name}",
  "overview.overdue": "Overdue",
  "overview.manage": "Manage",
  "overview.revision": "Revision {revision}",
  "overview.ai_budget": "AI budget",
  "overview.ai_this_month": "This month",
  "overview.ai_no_budget": "No budget set",
  "overview.activity": "Recent activity",
  "overview.no_activity": "No activity yet.",
  "overview.summary": "{count, plural, one {One item needs your attention today.} other {# items need your attention today.}}",
  "overview.summary_none": "Everything is up to date.",
  "overview.focus": "What you are working on today",
  "overview.attention": "Needs attention now",
  "overview.attention_empty_title": "Everything is up to date",
  "overview.attention_empty_body": "New enquiries, tasks and texts appear here as soon as there are any.",
  "overview.filter_clear": "Show all",
  "overview.stat_leads": "{count, plural, one {new enquiry} other {new enquiries}}",
  "overview.stat_tasks": "{count, plural, one {task for today} other {tasks for today}}",
  "overview.stat_texts": "{count, plural, one {text to do} other {texts to do}}",
  "overview.stat_imports": "{count, plural, one {import waiting} other {imports waiting}}",
  "overview.stat_channels": "{count, plural, one {portal rejection} other {portal rejections}}",
  "overview.row_reviews": "{count, plural, one {# text awaits your review} other {# texts await your review}}",
  "overview.row_reviews_meta": "Proposals in your languages",
  "overview.row_stale": "{count, plural, one {# translation is out of date} other {# translations are out of date}}",
  "overview.row_stale_meta": "The source text changed after it was translated",
  "overview.row_imports": "{count, plural, one {# import awaits review} other {# imports await review}}",
  "overview.row_imports_meta": "Check the differences before applying them",
  "overview.row_channels": "{count, plural, one {# portal listing rejected} other {# portal listings rejected}}",
  "overview.row_channels_meta": "The portal gave a reason; fix it and deliver again",
  "overview.row_failures": "{count, plural, one {# background job failed} other {# background jobs failed}}",
  "overview.row_failures_meta": "See the diagnostics in Settings",
  "overview.due_today": "Today",
  "overview.site_view": "View site",
  "overview.site_live": "Live",
  "overview.site_not_live": "Not live yet",
  "overview.site_preview_line": "Preview: revision {revision}, {when} ago"
}
